/* Emperielle — Global JS v4 (combo-aware variants + sold-out button lockdown) */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    mobileMenu();
    stickyHeader();
    revealOnScroll();
    productGallery();
    productOptions();
    quantityButtons();
    cartRemove();
    quickAdd();
    stickyAddGuard();
    updateOptionAvailability();
    syncBuyButtonsToCurrentVariant();
  }

  function mobileMenu() {
    const toggle = document.querySelector('.mobile-toggle');
    const drawer = document.querySelector('.mdrawer');
    const overlay = document.querySelector('.moverlay');
    const closeBtn = document.querySelector('.mdrawer__close');
    if (!toggle || !drawer) return;
    const open = () => { drawer.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
  }

  function stickyHeader() {
    const header = document.querySelector('.header');
    if (!header) return;
    const onScroll = () => { if (window.scrollY > 40) header.classList.add('scrolled'); else header.classList.remove('scrolled'); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function revealOnScroll() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    els.forEach(el => io.observe(el));
  }

  function productGallery() {
    const thumbs = document.querySelectorAll('[data-pgallery-thumb]');
    const main = document.querySelector('[data-pgallery-main]');
    if (!thumbs.length || !main) return;
    const mainImg = main.querySelector('img');
    if (!mainImg) return;

    const cache = {};
    thumbs.forEach(thumb => {
      const img = thumb.querySelector('img');
      const full = img?.dataset.full;
      if (full && !cache[full]) {
        const pre = new Image();
        pre.src = full;
        cache[full] = pre;
      }
    });

    function swapTo(full) {
      if (!full || mainImg.src === full) return;
      mainImg.style.transition = 'opacity 0.12s ease';
      mainImg.style.opacity = '0.35';
      const apply = () => { mainImg.src = full; requestAnimationFrame(() => { mainImg.style.opacity = '1'; }); };
      const cached = cache[full];
      if (cached && cached.complete) { apply(); }
      else {
        const tmp = new Image();
        tmp.onload = apply;
        tmp.src = full;
      }
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const img = thumb.querySelector('img');
        swapTo(img?.dataset.full);
      });
    });

    window.__galleryCache = cache;
    window.__gallerySwap = swapTo;

    if (window.matchMedia('(hover: hover)').matches) {
      main.addEventListener('mousemove', (e) => {
        const rect = main.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = `${x}% ${y}%`;
      });
      main.addEventListener('mouseenter', () => { mainImg.style.transform = 'scale(1.5)'; });
      main.addEventListener('mouseleave', () => { mainImg.style.transform = ''; mainImg.style.transformOrigin = ''; });
    }
  }

  function productOptions() {
    const groups = document.querySelectorAll('[data-popt-group]');
    if (!groups.length) return;
    groups.forEach(group => {
      const values = group.querySelectorAll('[data-popt-value]');
      values.forEach(v => {
        v.addEventListener('click', () => {
          values.forEach(x => x.classList.remove('selected'));
          v.classList.add('selected');
          const label = group.querySelector('[data-popt-selected]');
          if (label) label.textContent = v.dataset.poptValue;
          updateVariant();
          updateOptionAvailability();
        });
      });
    });
  }

  /* COMBO-AWARE: mark each option button unavailable if combining it with
     the user's selections in OTHER groups yields no available variant. */
  function updateOptionAvailability() {
    const variants = window.productVariants || [];
    if (!variants.length) return;
    const groups = document.querySelectorAll('[data-popt-group]');
    if (!groups.length) return;

    const selectedByIndex = [];
    groups.forEach(group => {
      const sel = group.querySelector('[data-popt-value].selected');
      selectedByIndex.push(sel ? sel.dataset.poptValue : null);
    });

    groups.forEach((group, gIdx) => {
      const values = group.querySelectorAll('[data-popt-value]');
      values.forEach(valEl => {
        const test = selectedByIndex.slice();
        test[gIdx] = valEl.dataset.poptValue;
        const match = variants.find(v => v.options.every((opt, i) => opt === test[i]));
        const ok = !!(match && match.available);
        if (ok) {
          valEl.classList.remove('is-unavailable');
          valEl.removeAttribute('aria-disabled');
        } else {
          valEl.classList.add('is-unavailable');
          valEl.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  function syncBuyButtonsToCurrentVariant() {
    const variants = window.productVariants || [];
    if (!variants.length) return;
    const groups = document.querySelectorAll('[data-popt-group]');
    const selected = [];
    groups.forEach(group => {
      const sel = group.querySelector('[data-popt-value].selected');
      if (sel) selected.push(sel.dataset.poptValue);
    });
    const match = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    applyBuyButtonState(match);
  }

  function applyBuyButtonState(match) {
    const available = !!(match && match.available);

    const addBtn = document.querySelector('[data-add-btn]');
    if (addBtn) {
      const txt = addBtn.querySelector('.prod__add-text');
      if (available) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        if (txt) txt.textContent = addBtn.dataset.textAdd || 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        if (txt) txt.textContent = addBtn.dataset.textSold || 'Sold Out';
      }
    }

    const buyNow = document.querySelector('.prod__buy-now');
    if (buyNow) {
      buyNow.disabled = !available;
      if (available) {
        buyNow.removeAttribute('aria-disabled');
        buyNow.style.display = '';
      } else {
        buyNow.setAttribute('aria-disabled', 'true');
        buyNow.style.display = 'none';
      }
    }

    const stickyAdd = document.querySelector('.prod__sticky-add');
    if (stickyAdd) {
      stickyAdd.disabled = !available;
      stickyAdd.textContent = available ? 'Add to Cart' : 'Sold Out';
      if (available) {
        stickyAdd.removeAttribute('aria-disabled');
        stickyAdd.style.opacity = '';
        stickyAdd.style.cursor = '';
        stickyAdd.style.pointerEvents = '';
      } else {
        stickyAdd.setAttribute('aria-disabled', 'true');
        stickyAdd.style.opacity = '0.5';
        stickyAdd.style.cursor = 'not-allowed';
        stickyAdd.style.pointerEvents = 'none';
      }
    }
  }

  /* The sticky-add button has an inline onclick that calls requestSubmit().
     Disabled <button> elements don't fire click, but inline onclick can
     still execute in edge cases. Capture-phase guard blocks it for safety. */
  function stickyAddGuard() {
    const stickyAdd = document.querySelector('.prod__sticky-add');
    if (!stickyAdd) return;
    stickyAdd.addEventListener('click', (e) => {
      if (stickyAdd.disabled || stickyAdd.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function updateVariant() {
    const selected = [];
    document.querySelectorAll('[data-popt-group]').forEach(group => {
      const sel = group.querySelector('[data-popt-value].selected');
      if (sel) selected.push(sel.dataset.poptValue);
    });
    const variants = window.productVariants || [];
    const match = variants.find(v => v.options.every((opt, i) => opt === selected[i]));

    if (!match) {
      applyBuyButtonState(null);
      return;
    }

    const idInput = document.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) priceEl.innerHTML = match.priceHTML;

    applyBuyButtonState(match);

    if (history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }
    if (match.imageSrc) {
      if (window.__gallerySwap) window.__gallerySwap(match.imageSrc);
      else {
        const main = document.querySelector('[data-pgallery-main] img');
        if (main && main.src !== match.imageSrc) main.src = match.imageSrc;
      }
    }
  }

  function quantityButtons() {
    document.querySelectorAll('[data-qty]').forEach(qty => {
      const input = qty.querySelector('input');
      if (!input) return;
      qty.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        const v = Math.max(parseInt(input.min || '1'), parseInt(input.value) - 1);
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      qty.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        input.value = parseInt(input.value) + 1; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function cartRemove() {
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const key = btn.dataset.cartRemove;
        try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); location.reload(); }
        catch (err) { console.error('Cart remove failed', err); }
      });
    });
  }

  function quickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const card = btn.closest('.pcard');
        const link = card?.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.href;
      });
    });
  }

})();
